import React, { FC } from "react";
import Head from "next/head";
import { baseUrl } from "services/shared/Environment";
import Script from "next/script";

const escapeQuotes = (str) =>
  str.replace(/[\u201C\u201D]/g, '"').replace(/\\/g, "\\");

interface NewsArticleSchemaProps {
  storyUrl: string;
  title: string;
  imageUrl: string;
  publicationDate: string;
  authorName: string;
  storySummary: string;
}

export const NewsArticleSchema: FC<NewsArticleSchemaProps> = ({
  storyUrl,
  title,
  imageUrl,
  publicationDate,
  authorName,
  storySummary,
}: NewsArticleSchemaProps) => {
  const schema = JSON.stringify({
    "@context": "http://schema.org",
    "@type": "NewsArticle",
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": `${storyUrl}`,
    },
    headline: `${escapeQuotes(title)}`,
    image: [`${imageUrl}`],
    datePublished: `${publicationDate}`,
    dateModified: `${publicationDate}`,
    dateCreated: `${publicationDate}`,
    author: {
      "@type": "Person",
      name: `${authorName}`,
    },
    publisher: {
      "@type": "Organization",
      name: "The Juggernaut",
      logo: {
        "@type": "ImageObject",
        url: `${baseUrl()}/static/wordmark_logo.png`,
        height: 25,
        width: 100,
      },
    },
    description: `${escapeQuotes(storySummary)}`,
    isAccessibleForFree: "False",
    hasPart: {
      "@type": "WebPageElement",
      isAccessibleForFree: "False",
      cssSelector: ".paywall-content",
    },
  });
  return (
    <Head>
      <Script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: schema,
        }}
      />
    </Head>
  );
};
